import axios from "axios";
import { API_URL } from "../index";

// FE-84: Services.js'ten taşındı (14 uç). Metotlar Services nesnesinde birleşir; this.X çağrıları çalışır.
const servisWeb = {
  GetWebPage(token, uri, lang = "tr") {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-web-page`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        uri,
        lang
      }
    });
  },

  // MÜŞTERİ ÖNER: nakliye merchant'ı bir müşteri önerir; BE type/channel/status/firma'yı zorlar.
  // serviceSubject: sabit konu listesinden seçilen etiket ya da "Diğer" seçilince serbest metin
  // (tek alanda nihai metin tutulur — bkz. utils/serviceSubjects).
  RecommendCustomer(token, { name, lastname, email, phone, countryCode, note, serviceSubject = "" }) {
    return axios({
      method: "post",
      url: `${API_URL}flow/recommend-customer`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: { name, lastname, email, phone, countryCode, note, serviceSubject }
    });
  },

  SendOfferMail(token, offerID) {
    const data = { offerID: offerID };
    return axios({
      method: "post",
      url: `${API_URL}flow/send-offer-mail`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data
    });
  },

  // Müşteri belgeleri (Profil > Belgeler): vergi levhası, imza sirküsü, kimlik ön/arka.
  // Admin customerID vererek başka müşterininkini görebilir/yükleyebilir.
  // ---- MEMNUNİYET ANKETLERİ (BE: surveys.php) ----
  // Admin listesi: müşterilere açılan anket davetleri. params: { userID?, surveyID?, operationID?,
  // status? (1 bekliyor, 2 cevaplandı), limit?, offset? } → { invitations: [...], total }.
  GetSurveyInvitations(token, params = {}) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-survey-invitations`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      data: params,
    });
  },
  // Anket tanımları. params: { type? ("depolama" | "nakliye"), limit?, offset? } → { surveys: [...] }.
  // Memnuniyet > Yanıtla anketi TÜRÜNE göre bununla çeker.
  GetSurveys(token, params = {}) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-surveys`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      data: params,
    });
  },
  // Cevaplanmamış daveti müşteriye (yeniden) e-postalar — Memnuniyet > Gönder / Tekrar Gönder.
  // Yeni davet açılmaz, link aynı kalır. Şablon (customer-experience-survey) kapalıyken mail
  // GİTMEZ ve hata döner. Sonuç: { sent, sentTo, mailSentCount, lastSentDateTime, ... }.
  ResendSurveyInvitation(token, invitationID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/resend-survey-invitation`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      data: { invitationID },
    });
  },
  // Tek davet: cevaplanmadıysa anketin soruları, cevaplandıysa answered=true + cevaplar.
  GetSurveyInvitation(token, invitationID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-survey-invitation`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      data: { invitationID },
    });
  },
  // Tek cevap: cevaplama anındaki soruların kopyası + cevaplar.
  GetSurveyAnswer(token, answerID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-survey-answer`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      data: { answerID },
    });
  },
  // Davet üzerinden cevap kaydı (Memnuniyet > Yanıtla: müşteriyi arayıp admin doldurur).
  // answers: [{ id, value }]. Kayıttan sonra davet kapanır (status=2).
  CreateSurveyAnswer(token, invitationID, answers) {
    return axios({
      method: "post",
      url: `${API_URL}flow/create-survey-answer`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      data: { invitationID, answers },
    });
  },

  GetMerchantMailingTemplates(token) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-merchant-mailing-templates`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      }
    });
  },

  GetMailingReceivers(token, companyID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-mailing-receivers`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        companyID
      }
    });
  },

  CreateMailingReceiver(token, companyID, users) {
    return axios({
      method: "post",
      url: `${API_URL}flow/create-mailing-receiver`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        companyID,
        users
      }
    });
  },

  UpdateMailingReceiver(token, companyID, users) {
    return axios({
      method: "post",
      url: `${API_URL}flow/update-mailing-receiver`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        companyID,
        users
      }
    });
  },

  GetMailingTemplates(token) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-mailing-templates`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
  },
};

export default servisWeb;
